export default __webpack_public_path__ + "static/media/plockuzzle_thumb.4eacd35d.png";